"use client";

import { useState } from "react";
import Image from "next/image";

import { cn } from "@/lib/utils";
import { getInitials, type TeamMember } from "@/features/team/team";

export function MemberPhoto({
  member,
  className,
  sizes = "200px",
  priority = false,
}: {
  member: TeamMember;
  className?: string;
  sizes?: string;
  priority?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  const initials = getInitials(member.name);

  return (
    <div
      className={cn(
        "relative aspect-[2/3] w-full max-w-[200px] overflow-hidden rounded-md border border-line bg-mist",
        className,
      )}
    >
      {failed ? (
        <div
          role="img"
          aria-label={member.photo.alt}
          className="flex h-full w-full flex-col items-center justify-center gap-1 px-2 text-navy-800"
        >
          <span aria-hidden="true" className="font-serif text-3xl font-bold">
            {initials}
          </span>
          <span className="text-center text-[0.65rem] leading-tight text-ink">
            Fotografie není dostupná
          </span>
        </div>
      ) : (
        <Image
          src={member.photo.src}
          alt={member.photo.alt}
          width={member.photo.width}
          height={member.photo.height}
          sizes={sizes}
          loading={priority ? "eager" : "lazy"}
          priority={priority}
          onError={() => setFailed(true)}
          className="h-full w-full object-cover"
        />
      )}
    </div>
  );
}
